import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { keys, omit } from 'lodash';
import { differenceObject, compareChanges } from '../../../../../utils/functions';
import LogChangesButton from './LogChangesButton';
import LogModal from '../../modals/LogModal';

const LogsDisplay = ({ logs}) => {
    // 添加本地状态
    const [modalState, setModalState] = useState({
        isOpen: false,
        modalType: '',
        olds: null,
        news: null
    });
    if (!logs || logs.length <= 0) {
        return <div>There are no logs to show.</div>;
    }

    // 处理模态框开关
    const handleShowModal = (modalData) => {
        setModalState({
            isOpen: true,
            modalType: modalData.modalType,
            olds: modalData.olds,
            news: modalData.news
        });
    };

    const handleCloseModal = () => {
        setModalState({
            isOpen: false,
            modalType: '',
            olds: null,
            news: null
        });
    };

    return logs.map((log) => {
        let differences = differenceObject(log.newDataRef, log.oldDataRef);
        const changes = compareChanges(log);

        // Process changes and remove processed fields
        differences = omit(differences, [
            'updatedAt',
            'steps',
            'faqs',
            'whitelist',
            'tags',
            'viewerTiers',
            'memberTiers',
            'stepsLanding',
            'stepsPage1',
            'stepsPage2',
            'stepsPage3',
            'blocks',
            'questTags',
            'trackingTags',
            'promoLinks',
            'completionRequirements',
            'requirements',
            'splitTiers',
            'rankTiers',
            'questDescriptions',
        ]);
        const objKeys = keys(differences);

        return (
            <div className="QFLog" key={log.id}>
                <div className="QFLog_top">
                    {log.user.username} - {moment(log.createdAt).format('MMMM DD, YYYY - hh:mm a')}
                </div>
                <div className="QFLog_bot">
                    {/* Render basic field changes */}
                    {objKeys.map((oKey) => {
                        let oKeyOld = <i>Empty</i>;
                        if (log.oldDataRef[oKey]) {
                            oKeyOld = log.oldDataRef[oKey];
                        } else if (log.oldDataRef[oKey] === '') {
                            oKeyOld = '';
                        } else if (log.oldDataRef[oKey] === false) {
                            oKeyOld = false;
                        } else if (log.oldDataRef[oKey] === false) {
                            oKeyOld = false;
                        } else if (typeof log.oldDataRef[oKey] === 'undefined') {
                            oKeyOld = <i>Undefined</i>;
                        }

                        let oKeyNew = <i>Empty</i>;
                        if (log.newDataRef[oKey]) {
                            oKeyNew = log.newDataRef[oKey];
                        } else if (log.newDataRef[oKey] === '') {
                            oKeyNew = '';
                        } else if (log.newDataRef[oKey] === false) {
                            oKeyNew = false;
                        } else if (typeof log.newDataRef[oKey] === 'undefined') {
                            oKeyNew = <i>Undefined</i>;
                        }

                        if (oKey === 'emailFailure') {
                            if (log.newDataRef[oKey] && log.newDataRef[oKey].shouldSend !== undefined) {
                                oKeyNew = `"Send Failure Email" set to ${log.newDataRef[oKey].shouldSend}`;
                            }

                            if (log.oldDataRef[oKey] && log.oldDataRef[oKey].shouldSend !== undefined) {
                                oKeyOld = `"Send Failure Email" set to ${log.oldDataRef[oKey].shouldSend}`;
                            }
                        }

                        if (oKey === 'emailReminder') {
                            if (log.newDataRef[oKey] && log.newDataRef[oKey].shouldSend !== undefined) {
                                oKeyNew = `"Send Reminder Email" set to ${log.newDataRef[oKey].shouldSend}`;
                            }

                            if (log.oldDataRef[oKey] && log.oldDataRef[oKey].shouldSend !== undefined) {
                                oKeyOld = `"Send Reminder Email" set to ${log.oldDataRef[oKey].shouldSend}`;
                            }
                        }

                        return (
                            <div key={oKey} className="QFLog_bot_key">
                                <React.Fragment>
                                    {oKey}:
                                    &nbsp;
                                    <span className="old">&nbsp;{oKeyOld?.toString() || oKeyOld}&nbsp;</span>
                                    &nbsp;-&nbsp;
                                    <span className="new">&nbsp;{oKeyNew?.toString() || oKeyNew}&nbsp;</span>
                                </React.Fragment>
                            </div>
                        );
                    })}



                    {/* Render special field changes */}
                    {Object.entries(changes).map(([type, data]) => {
                        if (data.changed) {
                            return (
                                <LogChangesButton
                                    key={type}
                                    title={`${type} changed`}
                                    oldData={data.old}
                                    newData={data.new}
                                    type={type}
                                    onClick={(type, old, new_) => {
                                        handleShowModal({
                                            modalType: type,
                                            olds: old,
                                            news: new_
                                        });
                                    }}
                                />
                            );
                        }
                        return null;
                    })}
                    {/* Show no changes message if needed */}
                    {!Object.values(changes).some(c => c.changed) &&
                        keys(differences).length === 0 &&
                        <div className="QFLog_bot_key">
                            No changes (pressed 'Save' without updating content)
                        </div>
                    }

                    {/* Button to show all changes in a modal */}
                    {modalState.isOpen && (
                        <LogModal
                            modalType={modalState.modalType}
                            olds={modalState.olds}
                            news={modalState.news}
                            onClose={handleCloseModal}
                        />
                    )}


                </div>
            </div>
        );
    });
};

LogsDisplay.propTypes = {
    logs: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            user: PropTypes.shape({
                username: PropTypes.string
            }),
            createdAt: PropTypes.string,
            newDataRef: PropTypes.object,
            oldDataRef: PropTypes.object
        })
    ),
    onChangeLogModal: PropTypes.func.isRequired
};

export default LogsDisplay;